module.exports = __webpack_public_path__ + "img/img_28.00045a61.png";